// src/pages/Enseignants/ListingAdherents/components/ListingAdherentsKpiCards.jsx

import React from "react";
import {
  FaBirthdayCake,
  FaCamera,
  FaUserInjured,
  FaUsers,
  FaUserSlash,
} from "react-icons/fa";

const CARDS = [
  {
    key: "total",
    label: "Affichés",
    icon: FaUsers,
    tone:
      "bg-blue-50 text-blue-700 ring-blue-200 dark:bg-blue-900/20 dark:text-blue-200 dark:ring-blue-800/60",
  },
  {
    key: "birthdays",
    label: "Anniversaires",
    icon: FaBirthdayCake,
    tone:
      "bg-pink-50 text-pink-700 ring-pink-200 dark:bg-pink-900/20 dark:text-pink-200 dark:ring-pink-800/60",
  },
  {
    key: "blessed",
    label: "Blessés / absents",
    icon: FaUserInjured,
    tone:
      "bg-red-50 text-red-700 ring-red-200 dark:bg-red-900/20 dark:text-red-200 dark:ring-red-800/60",
  },
  {
    key: "withoutPhoto",
    label: "Sans photo",
    icon: FaCamera,
    tone:
      "bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-900/20 dark:text-amber-200 dark:ring-amber-800/60",
  },
  {
    key: "stopped",
    label: "Arrêts",
    icon: FaUserSlash,
    tone:
      "bg-slate-50 text-slate-700 ring-slate-200 dark:bg-slate-800/60 dark:text-slate-200 dark:ring-slate-700",
  },
];

export default function ListingAdherentsKpiCards({ stats }) {
  return (
    <div className="grid grid-cols-2 gap-3 lg:grid-cols-5">
      {CARDS.map((card) => {
        const Icon = card.icon;

        return (
          <div
            key={card.key}
            className={`rounded-2xl px-4 py-3 ring-1 ${card.tone}`}
          >
            <div className="flex items-center justify-between gap-3">
              <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-white/70 dark:bg-white/10">
                <Icon />
              </span>

              <span className="text-2xl font-bold">
                {stats?.[card.key] ?? 0}
              </span>
            </div>

            <p className="mt-2 text-xs font-bold uppercase tracking-wide opacity-80">
              {card.label}
            </p>
          </div>
        );
      })}
    </div>
  );
}